import { jsx as _jsx } from "react/jsx-runtime";
import { trackEvent } from "services/bigbrain-service";
import { CAROUSEL_ARROW_CLICKED } from "constants/bigbrain-event-types";
import classnames from "classnames";
import { generateOnKeyDownHandler } from "client/services/accessibility/accessibility-service";
import NextArrow from "./next-arrow";
import { ARROW_TYPES, StyledArrow } from "./arrow.scss";
const NextCarouselArrow = ({ className, onClick, pause })=>{
    const onNextArrowClick = ()=>{
        if (onClick) {
            trackEvent(CAROUSEL_ARROW_CLICKED, {
                info1: "product-cards",
                info3: "next"
            });
            onClick();
        }
    };
    return /*#__PURE__*/ _jsx(StyledArrow, {
        type: ARROW_TYPES.NEXT,
        className: "overlay",
        children: /*#__PURE__*/ _jsx("button", {
            type: "button",
            className: classnames(className, "carousel-arrow-wrapper", "next"),
            onClick: onNextArrowClick,
            tabIndex: 0,
            onMouseEnter: pause,
            onKeyDown: generateOnKeyDownHandler(onClick),
            children: /*#__PURE__*/ _jsx(NextArrow, {})
        })
    });
};
export default NextCarouselArrow;
